import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["options", "optionRow", "optionText", "optionCorrect", "optionsJson", "template", "correctAnswer"]

    connect() {
        console.log("EvaluationQcmOptionsController connected")
        this.serializeOptions()
    }

    addOption(event) {
        event.preventDefault()
        const template = this.templateTarget
        const clone = template.content.cloneNode(true)
        this.optionsTarget.appendChild(clone)
        this.serializeOptions()
    }

    removeOption(event) {
        event.preventDefault()
        event.currentTarget.closest('[data-evaluation-qcm-options-target="optionRow"]').remove()
        this.serializeOptions()
    }

    serializeOptions() {
        const options = Array.from(this.optionRowTargets).map(row => {
            return {
                text: row.querySelector('[data-evaluation-qcm-options-target="optionText"]').value,
                correct: row.querySelector('[data-evaluation-qcm-options-target="optionCorrect"]').checked
            }
        })
        this.optionsJsonTarget.value = JSON.stringify(options)
    }

    optionChanged() {
        this.serializeOptions()
    }

    toggle(event) {
        const show = event.target.value === 'qcm'
        this.optionsTarget.parentElement.style.display = show ? 'block' : 'none'
        this.correctAnswerTarget.style.display = show ? 'none' : 'block'
    }

    optionTextTargetConnected() { this.serializeOptions() }
    optionCorrectTargetConnected() { this.serializeOptions() }
}
